import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { Button, Classes, Dialog, Intent, MenuItem } from '@blueprintjs/core';
import { observer } from 'mobx-react';
import { IconNames } from '@blueprintjs/icons';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import { Form } from 'react-final-form';
import SelectInputFormField from '../common/form/SelectInputFormField';
import DateInputFormField from '../common/form/DateInputFormField';
import { IItemRendererProps } from '@blueprintjs/select';
import { BankHolidayDate } from '../../store/models/BankHolidayDate';
import { FormType } from '../../common/enums/FormType';
import moment from 'moment';

interface BankHolidayDateFormProps extends WithTranslateProps {
  bankHolidayDate?: Instance<typeof BankHolidayDate>;
  bankHolidayList: any[];
  onSave: (data) => void;
  onStop: () => void;
  formType: FormType;
}

@observer
class BankHolidayDateForm extends React.Component<BankHolidayDateFormProps> {
  renderBankHolidayItem(item: any, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return <MenuItem key={`bk-${index}`} active={modifiers.active} onClick={handleClick} text={item.code} />;
    } else {
      return null;
    }
  }

  filterStatus = (query, bankHoliday) => {
    return bankHoliday.code.indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { onSave, onStop, bankHolidayDate, bankHolidayList, formType } = this.props;

    return (
      <Dialog
        isOpen={bankHolidayDate !== undefined}
        onClose={onStop}
        icon={IconNames.EDIT}
        canOutsideClickClose={false}
        title={
          <TranslatedMessage
            id={
              formType === FormType.CREATE
                ? TLCode.SECRETARIAT_DASHBOARD_BH_Create
                : TLCode.SECRETARIAT_DASHBOARD_BH_Edit
            }
          />
        }
      >
        {bankHolidayDate && (
          <div className={Classes.DIALOG_BODY}>
            <Form
              initialValues={{ ...bankHolidayDate, date: moment(bankHolidayDate.date, 'DD/MM/YYYY').toDate() }}
              onSubmit={onSave}
              render={({ handleSubmit, hasValidationErrors, dirty }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <DateInputFormField
                      name="date"
                      label={TLCode.SECRETARIAT_DASHBOARD_BankHolidayDateLabel}
                      inline={true}
                      fill={true}
                      maxDate={new Date('2099-12-31')}
                    />
                    <SelectInputFormField
                      label={TLCode.SECRETARIAT_DASHBOARD_BankHolidayLabel}
                      name="bankHolidayId"
                      inline={true}
                      items={bankHolidayList}
                      itemValueGetter={(item: any) => item.bankHolidayId}
                      valueItemGetter={(value) => bankHolidayList.find((bh) => bh.bankHolidayId === value)}
                      inputValueRenderer={(item) => (item != null ? item.code : '')}
                      itemRenderer={this.renderBankHolidayItem}
                      itemPredicate={this.filterStatus}
                      identifier={'bankHolidayId'}
                      elementLabel={'label'}
                      labelSelectAnElement={this.props.translate(TLCode.SECRETARIAT_DASHBOARD_SelectBankHoliday)}
                      helperText={this.props.translate(TLCode.SECRETARIAT_DASHBOARD_SelectBankHoliday)}
                      placeholderSelection={TLCode.SECRETARIAT_DASHBOARD_SelectBankHoliday}
                    />
                    <div className={Classes.DIALOG_FOOTER}>
                      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text={<TranslatedMessage id={TLCode.GENERAL_Cancel} />} onClick={onStop} />
                        <Button
                          type="submit"
                          intent={Intent.PRIMARY}
                          disabled={hasValidationErrors || (!dirty && bankHolidayDate.bankHolidayDateId > 0)}
                          text={<TranslatedMessage id={TLCode.GENERAL_Save} />}
                        />
                      </div>
                    </div>
                  </form>
                );
              }}
            />
          </div>
        )}
      </Dialog>
    );
  }
}

export default withTranslate(BankHolidayDateForm);
